import { StringMap } from '@/shared/utils/map'
import { FormAttributeDefinition } from '@/shared/forms/form-attribute-definition'
import { defaultSerializer } from '@/shared/forms/default-serializer'
import { defaultDeserializer } from '@/shared/forms/default-deserializer'

export function FormAttribute(options: Partial<FormAttributeDefinition> = {}): PropertyDecorator {
  return (target, propertyKey) => {
    const metadata: StringMap<FormAttributeDefinition> = Reflect.getMetadata('form', target) || {}
    const key: string = typeof propertyKey === 'string' ? propertyKey : propertyKey.description!

    if (metadata.hasOwnProperty(key) === false) {
      if (options.name === undefined) {
        if (typeof propertyKey === 'string') {
          options.name = propertyKey
        } else {
          options.name = propertyKey.description!
        }
      }

      if (options.selector === undefined) {
        options.selector = options.name
      }

      options.deserialize = options.deserialize || defaultDeserializer
      options.serialize = options.serialize || defaultSerializer
      options.validators = options.validators || {}

      metadata[options.name] = options as FormAttributeDefinition
    }

    Reflect.defineMetadata('form', metadata, target)
  }
}
